import { useState, useEffect } from 'react';

//Hook
import useUser from '../user/useUser';
// Service
import stockControlService from '../../services/stockControlService';

const useWarehouse = (defaultFilters) => {
    const [loading, setLoading] = useState(true);
    const { business } = useUser();
    const [filters, setFilters] = useState({
        ...defaultFilters,
        pageSize: 10,
        pageNumber: 1,
        businessId: business.id,
        country: defaultFilters.country ? business.country : null,
    });
    const [searchResult, setSearchResult] = useState({
        warehouses: [],
        totalResults: 0,
        totalPage: 0
    });

    useEffect(() => {
        if (business.id)
            setFilters(state => ({
                ...state,
                businessId: business.id,
                country: defaultFilters.country ? business.country : null
            }));
    }, [business.id])

    useEffect(() => {
        const abortController = new AbortController();

        const FindWarehouses = async () => {
            setLoading(true);
            const res = await stockControlService.GetWarehouses(filters)

            setSearchResult({
                warehouses: res.values,
                totalPage: res.totalPage,
                totalResults: res.totalResults
            })

            setLoading(false);
        }

        if (filters && (filters.businessId || filters.country)) {
            FindWarehouses();
        }

        return () => {
            abortController.abort();
        };
    }, [filters])

    const FindWarehouseByID = async (warehouseId) =>
        await stockControlService.GetWarehouseById(warehouseId);

    return {
        ...searchResult,
        FindWarehouseByID,
        setFilters,
        filters,
        loading
    }
}

export default useWarehouse;